// import featherlightGallery from 'featherlight/release/featherlight.gallery.min.js';
// import "featherlight/release/featherlight.min.css";
// import "featherlight/release/featherlight.gallery.min.css";
// import '../plugins/custom-select.min.js';
import 'iframe-resizer';
import { initAnimations } from './animationer.js'

export default () => {
    initAnimations();

    const buttons = document.querySelectorAll('a[href*="popup-"]');
    if(buttons.length > 0) {
        const popup = document.getElementById('pop-target');
        const popup_heading = document.getElementById('pop-heading');
        const popup_content = document.getElementById('pop-content');
        buttons.forEach(button => {
          const href = button.getAttribute('href');
          let id = href.split('opup-')[1];
          let extras = "";
          if(id.includes('?')) {
            extras = id.split('?')[1];
            id = id.split('?')[0];
          }
          button.addEventListener('click', e => {
            event.preventDefault();
            document.body.classList.add("stop-scrolling");
            fetch('/wp-json/popup/v1/page', {
              method: 'POST',
              headers: {
                'Content-type': 'application/json',
              },
              body: JSON.stringify({ "id": id, "extras": extras })
            })
            .then(response => response.json())
            .then(data => {
              if(popup_content.getAttribute('src') !== data){
                popup_content.setAttribute('src', data);
              }
              iFrameResize({}, popup_content);
              window.addEventListener('resize', e => {
                iFrameResize({}, popup_content);
              });
              setTimeout(setFocusIframe, 100);
              popup.classList.add('active');
              popup.querySelectorAll('.pop__bg, .pop__closer').forEach(item => {
                item.addEventListener('click', e => {
                  popup.classList.remove('active');
                  document.body.classList.remove("stop-scrolling");
                  button.focus();
                });
              })
            });
          })
        });
    }

    function setFocusIframe() {
        const iframe = $("#pop-content")[0];
        iframe.contentWindow.focus();
    }

    if(window.location.href.indexOf("#") > -1) {
        // store the hash (DON'T put this code inside the $() function, it has to be executed
        // right away before the browser can start scrolling!
        var target = window.location.hash,
            target = target.replace('#', '');

        // delete hash so the page won't scroll to it
        window.location.hash = "";
        (function() {
            if(target) {
                var word = document.getElementById(target);
                setTimeout(function() {
                    word.scrollIntoView({behavior: "smooth", block: 'center'});
                    var targetBtn = document.querySelector('#' + target + ' button');
                    if(!targetBtn) {
                        targetBtn = document.querySelector('#' + target);
                    }
                    targetBtn.click();
                }, 500);
            }
        })();
    }

    if(document.querySelectorAll('.page__content').length > 0) {
        markBody(document.querySelector('.page__content').querySelectorAll('*')[0]);
    } else if(document.querySelectorAll('.post__content').length > 0) {
        markBody(document.querySelector('.post__content').querySelectorAll('*')[0]);
    }

    function markBody(firstChild) {
        if(firstChild && (firstChild.classList.contains('hero') || firstChild.classList.contains('extended-carousel') || firstChild.classList.contains('fac-hero') || firstChild.classList.contains('map-hero') || firstChild.classList.contains('wp-image') || firstChild.classList.contains('wp-block-cover'))) {
            document.body.classList.add('image');
        }
    }

    if(window.screen.width < 781) {
        if(document.querySelectorAll('.wp-block-columns').length > 0) {
            document.querySelectorAll('.wp-block-columns').forEach(item => {
                const empties = item.querySelectorAll('.wp-block-column:empty')
                if(empties.length > 0) {
                    empties.forEach(sub => {
                        sub.style.display = "none";
                    });
                    const leftOvers = item.querySelectorAll('.wp-block-column');
                    if(leftOvers.length === 1) {
                        leftOvers[0].style.flexBasis = "100%";
                        leftOvers[0].style.marginTop = "0";
                    }
                }
            });
        }
        document.querySelectorAll('.wp-block-spacer').forEach(item => {
            if(item.offsetHeight > 200) {
                item.style.height = (item.offsetHeight/2) + "px";
            }
        })
    }

    const subMenu = document.querySelector('.page-sub-menu');
    if(subMenu) {
        if(window.screen.width > 1024) {
            subMenu.addEventListener('mouseenter', e => {
                document.querySelector('#header .bg').classList.add('active');
            })
            subMenu.addEventListener('mouseleave', e => {
                document.querySelector('#header .bg').classList.remove('active');
            })
        }
    }

    document.querySelectorAll('.sweden-map').forEach(map => {
        map.querySelectorAll('.location-link').forEach(link => {
            link.addEventListener('mouseover', e => {
                const place = link.getAttribute('data-place');
                map.querySelectorAll('path[data-place="'+ place +'"').forEach(p => {
                    p.classList.add('active');
                })
            });
            link.addEventListener('mouseout', e => {
                const place = link.getAttribute('data-place');
                map.querySelectorAll('path[data-place="'+ place +'"').forEach(p => {
                    p.classList.remove('active');
                })
            });
        });
        map.querySelectorAll('strong.location-link').forEach(link => {
            link.addEventListener('click', e => {
                map.querySelectorAll('.location-link.sub.visible').forEach(l => {
                    l.classList.remove('visible');
                })
                const place = link.getAttribute('data-place');
                map.querySelectorAll('.location-link.sub[data-place="'+ place +'"').forEach(p => {
                    p.classList.toggle('visible');
                })
            })
        });
        map.querySelectorAll('path[data-place]').forEach(path => {
            const place = path.getAttribute('data-place');
            path.addEventListener('click', e => {
                map.querySelectorAll('.location-link.sub.visible').forEach(l => {
                    l.classList.remove('visible');
                })
                const url = map.querySelector('.location-link[data-place="'+ place +'"]').getAttribute('href');
                if(url && url !== undefined) {
                    window.location.href = url;
                } else {
                    map.querySelectorAll('.location-link.sub[data-place="'+ place +'"]').forEach(l => {
                        l.classList.toggle('visible')
                    })
                }
            });
            path.addEventListener('mouseover', e => {
                const place = path.getAttribute('data-place');
                map.querySelectorAll('.location-link[data-place="'+ place +'"]:not(.sub)').forEach(l => {
                    l.classList.add('active');
                });
            });
            path.addEventListener('mouseout', e => {
                const place = path.getAttribute('data-place');
                map.querySelectorAll('.location-link[data-place="'+ place +'"]:not(.sub)').forEach(l => {
                    l.classList.remove('active');
                });
            });
        })
    })
};
